module.exports = __webpack_public_path__ + "static/img/img-honor2.67fcc56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-honor2.png
// module id = TRWr
// module chunks = 1